import gql from '@/services/gql';

export const commonActions = [
  'component',
  'material',
  'vendor',
].map(estate => ({
  title: `Add ${estate} to database`,
  url: `/${estate}s/create`,
  icon: 'add',
})).concat({
  title: 'Create tech pack for a new product',
  url: '/products/create',
  icon: 'add',
}, {
  title: 'Create linesheet for wholesale',
  url: '/linesheets/create',
  icon: 'add',
});

export const menuItems = [
  {
    title: 'Core',
    items: [
      {
        estate: 'components',
        description: 'Database of components',
        icon: 'query-outer-join',
      },
      {
        estate: 'materials',
        description: 'Database of materials',
        icon: '360-degrees',
      },
      {
        estate: 'products',
        description: 'Product database with tech packs for development and production',
        icon: 'data-recovery',
      },
      {
        estate: 'vendors',
        description: 'Your manufacturers and suppliers of components and materials',
        icon: 'venn-diagram',
      },
    ],
  },
  {
    title: 'Apps',
    items: [
      {
        estate: 'batches',
        description: 'Quantify resources required to manufacture a batch of products',
        icon: 'replicate-rows',
      },
      {
        estate: 'linesheets',
        description: 'Present products to potential buyers',
        icon: 'select-table',
      },
    ],
  },
];

interface ResponseAggregate {
  aggregate: {
    count: number;
  };
}

interface CountsResponseType {
  component: ResponseAggregate;
  material: ResponseAggregate;
  product: ResponseAggregate;
  vendor: ResponseAggregate;
}

export const getCounts = gql<CountsResponseType>(`
query Counts {
  component: component_aggregate {
    aggregate {
      count(distinct: true)
    }
  }
  material: material_aggregate {
    aggregate {
      count(distinct: true)
    }
  }
  product: product_aggregate {
    aggregate {
      count(distinct: true)
    }
  }
  vendor: vendor_aggregate {
    aggregate {
      count(distinct: true)
    }
  }
}`);
